<template>
    <div class="minisite-video-list" :style="getListStyle">
        <template-00 v-if="data.style.templateId === '00'" :data="data"></template-00>
        <template-01 v-if="data.style.templateId === '01'" :data="data"></template-01>
    </div>
</template>
<script>
    import CommonMixIn from './common.mixin'

    import VideoTemplate from './video'

    export default {
        name: "VideoComponent",
        mixins: [CommonMixIn],
        components: {
            'template-00': VideoTemplate.Template00,
            'template-01': VideoTemplate.Template01
        },
        computed: {
            getListStyle() {
                if (this.data.style && this.data.style.background) {
                    return Object.assign(
                        {},
                        this.getBackground(this.data.style.background),
                        this.getPadding(this.data.style.background.padding),
                        this.getMargin(this.data.style.background.margin)
                    )
                }
                return {}
            }
        }
    }
</script>

<style lang="less" scoped>

</style>
